import { __extends } from "tslib";
import { NumericScaleMode_$type } from "./NumericScaleMode";
import { IgrNumericAxisBase } from "./igr-numeric-axis-base";
import { ensureEnum } from "igniteui-react-core";
/**
 * Defines a set of basic methods and properties used to create a StraightNumeric axis.
*/
var IgrStraightNumericAxisBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrStraightNumericAxisBase, _super);
    function IgrStraightNumericAxisBase(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(IgrStraightNumericAxisBase.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrStraightNumericAxisBase.prototype, "scaleMode", {
        /**
         * Gets or sets the axis scale mode.
        *
        * `ScaleMode` can be used on numeric axes to allow scaling data values using built-in scalers. The available scalers are linear or logarithmic.
        *
        * ```ts
        * this.yAxis.scaleMode = NumericScaleMode.Logarithmic;
        * ```
        *
        * ```ts
        *  <IgrDataChart
        *     dataSource={this.state.dataSource} >
        *
        *     <IgrCategoryXAxis name="xAxis" />
        *     <IgrNumericYAxis name="yAxis"
        * 	scaleMode="logarithmic" />
        *
        *     <IgrLineSeries
        *      name="series1"
        *     xAxisName="xAxis"
        * 	yAxisName="yAxis"
        * 	valueMemberPath="Value" />
        *  </IgrDataChart>
        * ```
        */
        get: function () {
            return this.i.nh;
        },
        set: function (v) {
            this.i.nh = ensureEnum(NumericScaleMode_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrStraightNumericAxisBase;
}(IgrNumericAxisBase));
export { IgrStraightNumericAxisBase };
